import {
  CanvasImg,
  EllaShopify,
  FloatingiPhone1,
  FloatingiPhone2,
  FloatingiPhone3,
  Metronic,
  RealHomes1,
  RealHomes2,
  RealHomes3,
  ThreeDModels1,
  ThreeDModels2,
  WoodMart1,
  WoodMart2,
  WoodMart3,
  WoodMart4,
} from "../images";

export const trendingsProducts: {
  imgs: string[];
  title: string;
  by: string;
  price: string;
}[] = [
  {
    imgs: [WoodMart1, WoodMart2, WoodMart3, WoodMart4],
    title: "WoodMart - Multipurpose Wordpress Theme",
    by: "xtemos",
    price: "59$",
  },
  {
    imgs: [RealHomes1, RealHomes2, RealHomes3],
    title: "RealHomes - Estate Sale and Rental WordPress Theme",
    by: "InspiryThemes",
    price: "59$",
  },
  {
    imgs: [EllaShopify],
    title: "Ella - Multipurpose Shopify Theme OS 2.0",
    by: "halothemes",
    price: "89$",
  },
  {
    imgs: [Metronic],
    title:
      "Metronic | Bootstrap HTML, VueJS, React, Angular, Asp.Net, Django & Laravel Admin Dashboard Theme",
    by: "keenthemes",
    price: "49$",
  },
  {
    imgs: [CanvasImg],
    title: "Canvas | The Multi-Purpose HTML5 Template",
    by: "SemiColonWeb",
    price: "16$",
  },
  {
    imgs: [FloatingiPhone1, FloatingiPhone2, FloatingiPhone3],
    title: "Floating iPhone 12 Mockups (PSD)",
    by: "Blueskytechco in Mockups",
    price: "15$",
  },
  {
    imgs: [ThreeDModels1, ThreeDModels2],
    title: "3DModels",
    by: "3DModels Company",
    price: "80$",
  },
];
